/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Itemnotfound_Description2Inputs */

const he_itemnotfound_description2 = /** @type {(inputs: Itemnotfound_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נראה שהמוצר הזה עדיין לא נוסף ל-Pricedrop, או שהוא פשוט לא קיים. קורה לטובים.`)
};

const en_itemnotfound_description2 = /** @type {(inputs: Itemnotfound_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looks like this product hasn't been added to Pricedrop yet, or it simply doesn't exist. It happens to the best of us.`)
};

/**
* | output |
* | --- |
* | "Looks like this product hasn't been added to Pricedrop yet, or it simply doesn't exist. It happens to the best of us." |
*
* @param {Itemnotfound_Description2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const itemnotfound_description2 = /** @type {((inputs?: Itemnotfound_Description2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Itemnotfound_Description2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_itemnotfound_description2(inputs)
	return en_itemnotfound_description2(inputs)
});
export { itemnotfound_description2 as "itemNotFound_description" }